import vftEnglish from "../locales/en";
import vftSpanish from "../locales/es";
import i18next from "i18next";

const translations = {
  en: {
    translation: vftEnglish
  },
  es: {
    translation: vftSpanish
  }
};

export const language = navigator.language.split(/[-_]/)[0] || 'en';

i18next.init({
  useLocalStorage: true,
  useDataAttrOptions:true,
  interpolation: { escapeValue: false },
  lng: language,
  resources: translations,
  backend: {
    loadPath: translations[language]
  },
});

const translate = (id: string, values?: {}) => {
  return i18next.t(id, values);
};

export default translate;